import React, { useState } from 'react';
import AttachmentUpload from './AttachmentUpload';

const RoyalCaribbeanCruiseForm = ({ onSave, onCancel, initialData = {} }) => {
  const [formData, setFormData] = useState({
    title: 'Royal Caribbean Cruise',
    ship_name: '',
    cruise_length: '7-Night',
    departure_date: '',
    return_date: '',
    departure_port: '',
    departure_port_other: '',
    destination: '',
    itinerary: '',
    stateroom_category: '',
    stateroom_number: '',
    deck: '',
    stateroom_location: '',
    dining_package: '',
    dining_time: '',
    shore_excursions: '',
    shore_excursions_price: 0,
    onboard_activities: '',
    entertainment: '',
    specialty_restaurants: '',
    specialty_dining_price: 0,
    beverage_package: 'Not Included',
    beverage_package_price: 0,
    internet_package: 'Not Included',
    internet_package_price: 0,
    photo_package: 'Not Included',
    photo_package_price: 0,
    gratuities: 'Included',
    gratuities_price: 0,
    spa_services: '',
    spa_services_price: 0,
    travel_protection: 'Not Included',
    travel_protection_price: 0,
    total_price: 0,
    total_price_due_by: '',
    deposit_due: 0,
    deposit_due_by: '',
    final_payment_due: '',
    special_requests: '',
    celebration_details: '',
    accessibility_needs: '',
    children: [],
    isOption: false,
    optionDescription: '',
    photos: [],
    documents: [],
    ...initialData
  });

  const [errors, setErrors] = useState({});

  // Royal Caribbean Ships by Class
  const shipOptions = [
    // Oasis Class
    'Symphony of the Seas',
    'Harmony of the Seas', 
    'Allure of the Seas',
    'Oasis of the Seas',
    'Wonder of the Seas',
    'Utopia of the Seas',
    // Voyager Class
    'Voyager of the Seas',
    'Explorer of the Seas',
    'Adventure of the Seas',
    'Navigator of the Seas',
    'Mariner of the Seas',
    // Freedom Class
    'Freedom of the Seas',
    'Liberty of the Seas',
    'Independence of the Seas',
    // Radiance Class
    'Radiance of the Seas',
    'Brilliance of the Seas',
    'Jewel of the Seas',
    'Serenade of the Seas',
    // Vision Class
    'Vision of the Seas',
    'Rhapsody of the Seas',
    'Enchantment of the Seas',
    'Grandeur of the Seas',
    'Legend of the Seas',
    'Splendour of the Seas',
    // Icon Class (Newest)
    'Icon of the Seas',
    'Star of the Seas',
    // Quantum Class
    'Quantum of the Seas',
    'Anthem of the Seas',
    'Ovation of the Seas',
    'Odyssey of the Seas',
    'Spectrum of the Seas'
  ];

  const cruiseLengthOptions = [
    '1-Night',
    '2-Night',
    '3-Night',
    '4-Night',
    '5-Night',
    '6-Night',
    '7-Night',
    '8-Night',
    '9-Night',
    '10-Night',
    '11-Night',
    '12-Night',
    '14-Night',
    '15-Night',
    '16-Night',
    '18-Night',
    '21-Night'
  ];

  const departurePortOptions = [
    'Miami, Florida',
    'Fort Lauderdale, Florida',
    'Port Canaveral, Florida',
    'Tampa, Florida',
    'New Orleans, Louisiana',
    'Galveston, Texas',
    'New York, New York',
    'Baltimore, Maryland',
    'Boston, Massachusetts',
    'Seattle, Washington',
    'Los Angeles (San Pedro), California',
    'San Francisco, California',
    'Long Beach, California',
    'San Diego, California',
    'Vancouver, Canada',
    'San Juan, Puerto Rico',
    'Barbados',
    'Barcelona, Spain',
    'Rome (Civitavecchia), Italy',
    'Venice, Italy',
    'Southampton, England',
    'Copenhagen, Denmark',
    'Stockholm, Sweden',
    'Singapore',
    'Sydney, Australia',
    'Hong Kong',
    'Other (Please Specify)'
  ];

  const destinationOptions = [
    'Caribbean - Western',
    'Caribbean - Eastern',
    'Caribbean - Southern',
    'Bahamas',
    'Bermuda',
    'Alaska - Inside Passage',
    'Alaska - Glacier Bay',
    'Mediterranean - Western',
    'Mediterranean - Eastern',
    'Northern Europe/Baltic',
    'Norwegian Fjords',
    'British Isles',
    'Transatlantic',
    'Panama Canal',
    'Hawaii',
    'Asia',
    'Australia/New Zealand',
    'Canada/New England',
    'Mexico - Mexican Riviera',
    'Repositioning',
    'World Cruise'
  ];

  const stateroomCategories = [
    'Interior Stateroom',
    'Ocean View Stateroom',
    'Balcony Stateroom',
    'Junior Suite',
    'Grand Suite',
    'Owner\'s Suite',
    'Royal Suite',
    'Presidential Suite',
    'Villa Suite',
    'Loft Suite',
    'Panoramic Suite',
    'Spacious Ocean View',
    'Promenade View',
    'Central Park View',
    'Boardwalk View',
    'Virtual Balcony'
  ];

  const diningPackageOptions = [
    'My Time Dining (Flexible)',
    'Traditional Dining - Early Seating',
    'Traditional Dining - Late Seating',
    'Specialty Dining Package',
    'Ultimate Dining Package',
    'Chef\'s Table Experience'
  ];

  const diningTimeOptions = [
    '5:30 PM (Early Seating)',
    '8:00 PM (Late Seating)',
    'My Time Dining (Flexible)'
  ];

  const beveragePackageOptions = [
    'Not Included',
    'Classic Soda Package',
    'Refreshment Package',
    'Deluxe Beverage Package',
    'Premium Beverage Package',
    'Ultimate Beverage Package'
  ];

  const internetPackageOptions = [
    'Not Included',
    'Surf Package',
    'Surf + Stream Package',
    'VOOM Surf + Stream'
  ];

  const photoPackageOptions = [
    'Not Included',
    'All Access Photo Package',
    'Select Photo Package'
  ];

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const addChild = () => {
    setFormData(prev => ({
      ...prev,
      children: [...prev.children, { age: '' }]
    }));
  };

  const removeChild = (index) => {
    setFormData(prev => ({
      ...prev,
      children: prev.children.filter((_, i) => i !== index)
    }));
  };

  const updateChild = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      children: prev.children.map((child, i) => 
        i === index ? { ...child, [field]: value } : child
      )
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.ship_name) newErrors.ship_name = 'Ship name is required';
    if (!formData.departure_date) newErrors.departure_date = 'Departure date is required';
    if (!formData.departure_port) newErrors.departure_port = 'Departure port is required';
    if (formData.departure_port === 'Other (Please Specify)' && !formData.departure_port_other) {
      newErrors.departure_port_other = 'Please specify the departure port';
    }
    if (!formData.destination) newErrors.destination = 'Destination is required';
    if (!formData.stateroom_category) newErrors.stateroom_category = 'Stateroom category is required';
    if (!formData.total_price || formData.total_price <= 0) newErrors.total_price = 'Total price is required';
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Royal Caribbean Cruise form submitted with data:', formData);
    
    if (validateForm()) {
      const componentData = {
        type: 'royal-caribbean-cruise',
        title: formData.title,
        price: formData.total_price,
        isOption: formData.isOption,
        optionDescription: formData.optionDescription,
        paymentTiming: formData.paymentTiming,
        optionalDepositAmount: formData.optionalDepositAmount,
        photos: formData.photos,
        documents: formData.documents,
        data: {
          ship_name: formData.ship_name,
          cruise_length: formData.cruise_length,
          departure_date: formData.departure_date,
          return_date: formData.return_date,
          departure_port: formData.departure_port,
          departure_port_other: formData.departure_port_other,
          destination: formData.destination,
          itinerary: formData.itinerary,
          stateroom_category: formData.stateroom_category,
          stateroom_number: formData.stateroom_number,
          deck: formData.deck,
          stateroom_location: formData.stateroom_location,
          dining_package: formData.dining_package,
          dining_time: formData.dining_time,
          shore_excursions: formData.shore_excursions,
          shore_excursions_price: formData.shore_excursions_price,
          onboard_activities: formData.onboard_activities,
          entertainment: formData.entertainment,
          specialty_restaurants: formData.specialty_restaurants,
          specialty_dining_price: formData.specialty_dining_price,
          beverage_package: formData.beverage_package,
          beverage_package_price: formData.beverage_package_price,
          internet_package: formData.internet_package,
          internet_package_price: formData.internet_package_price,
          photo_package: formData.photo_package,
          photo_package_price: formData.photo_package_price,
          gratuities: formData.gratuities,
          gratuities_price: formData.gratuities_price,
          spa_services: formData.spa_services,
          spa_services_price: formData.spa_services_price,
          travel_protection: formData.travel_protection,
          travel_protection_price: formData.travel_protection_price,
          total_price: formData.total_price,
          total_price_due_by: formData.total_price_due_by,
          deposit_due: formData.deposit_due,
          deposit_due_by: formData.deposit_due_by,
          final_payment_due: formData.final_payment_due,
          special_requests: formData.special_requests,
          celebration_details: formData.celebration_details,
          accessibility_needs: formData.accessibility_needs,
          children: formData.children
        }
      };
      console.log('Calling onSave with:', componentData);
      onSave(componentData);
    } else {
      console.log('Form validation failed with errors:', errors);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="component-form royal-caribbean-cruise-form">
      <div className="form-section">
        <h4>Cruise Details</h4>
        <div className="form-row">
          <div className="form-group">
            <label>Package Title</label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              className="form-control"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Royal Caribbean Ship *</label>
            <select
              name="ship_name"
              value={formData.ship_name}
              onChange={handleInputChange}
              className={`form-control ${errors.ship_name ? 'error' : ''}`}
            >
              <option value="">Select Ship</option>
              {shipOptions.map(ship => (
                <option key={ship} value={ship}>{ship}</option>
              ))}
            </select>
            {errors.ship_name && <span className="error-message">{errors.ship_name}</span>}
          </div>
          <div className="form-group">
            <label>Cruise Length</label>
            <select
              name="cruise_length"
              value={formData.cruise_length}
              onChange={handleInputChange}
              className="form-control"
            >
              {cruiseLengthOptions.map(length => (
                <option key={length} value={length}>{length}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Departure Date *</label>
            <input
              type="date"
              name="departure_date"
              value={formData.departure_date}
              onChange={handleInputChange}
              className={`form-control ${errors.departure_date ? 'error' : ''}`}
            />
            {errors.departure_date && <span className="error-message">{errors.departure_date}</span>}
          </div>
          <div className="form-group">
            <label>Return Date</label>
            <input
              type="date"
              name="return_date"
              value={formData.return_date}
              onChange={handleInputChange}
              className="form-control"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Departure Port *</label>
            <select
              name="departure_port"
              value={formData.departure_port}
              onChange={handleInputChange}
              className={`form-control ${errors.departure_port ? 'error' : ''}`}
            >
              <option value="">Select Departure Port</option>
              {departurePortOptions.map(port => (
                <option key={port} value={port}>{port}</option>
              ))}
            </select>
            {errors.departure_port && <span className="error-message">{errors.departure_port}</span>}
          </div>
          {formData.departure_port === 'Other (Please Specify)' && (
            <div className="form-group">
              <label>Specify Departure Port *</label>
              <input
                type="text"
                name="departure_port_other"
                value={formData.departure_port_other}
                onChange={handleInputChange}
                placeholder="e.g., Southampton (London), UK"
                className={`form-control ${errors.departure_port_other ? 'error' : ''}`}
              />
              {errors.departure_port_other && <span className="error-message">{errors.departure_port_other}</span>}
            </div>
          )}
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Destination *</label>
            <select
              name="destination"
              value={formData.destination}
              onChange={handleInputChange}
              className={`form-control ${errors.destination ? 'error' : ''}`}
            >
              <option value="">Select Destination</option>
              {destinationOptions.map(dest => (
                <option key={dest} value={dest}>{dest}</option>
              ))}
            </select>
            {errors.destination && <span className="error-message">{errors.destination}</span>}
          </div>
        </div>

        <div className="form-group">
          <label>Itinerary Details</label>
          <textarea
            name="itinerary"
            value={formData.itinerary}
            onChange={handleInputChange}
            placeholder="Port stops, sea days, special events..."
            className="form-control"
            rows="3"
          />
        </div>
      </div>

      <div className="form-section">
        <h4>Stateroom Details</h4>
        <div className="form-row">
          <div className="form-group">
            <label>Stateroom Category *</label>
            <select
              name="stateroom_category"
              value={formData.stateroom_category}
              onChange={handleInputChange}
              className={`form-control ${errors.stateroom_category ? 'error' : ''}`}
            >
              <option value="">Select Stateroom Category</option>
              {stateroomCategories.map(category => (
                <option key={category} value={category}>{category}</option>
              ))}
            </select>
            {errors.stateroom_category && <span className="error-message">{errors.stateroom_category}</span>}
          </div>
          <div className="form-group">
            <label>Stateroom Number</label>
            <input
              type="text"
              name="stateroom_number"
              value={formData.stateroom_number}
              onChange={handleInputChange}
              placeholder="e.g., 9254"
              className="form-control"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Deck</label>
            <input
              type="text"
              name="deck"
              value={formData.deck}
              onChange={handleInputChange}
              placeholder="e.g., Deck 9"
              className="form-control"
            />
          </div>
          <div className="form-group">
            <label>Stateroom Location</label>
            <select
              name="stateroom_location"
              value={formData.stateroom_location}
              onChange={handleInputChange}
              className="form-control"
            >
              <option value="">Select Location</option>
              <option value="Forward">Forward</option>
              <option value="Midship">Midship</option>
              <option value="Aft">Aft</option>
            </select>
          </div>
        </div>
      </div>

      <div className="form-section">
        <h4>Dining & Entertainment</h4>
        <div className="form-row">
          <div className="form-group">
            <label>Dining Package</label>
            <select
              name="dining_package"
              value={formData.dining_package}
              onChange={handleInputChange}
              className="form-control"
            >
              <option value="">Select Dining Package</option>
              {diningPackageOptions.map(pkg => (
                <option key={pkg} value={pkg}>{pkg}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Main Dining Time</label>
            <select
              name="dining_time"
              value={formData.dining_time}
              onChange={handleInputChange}
              className="form-control"
            >
              <option value="">Select Dining Time</option>
              {diningTimeOptions.map(time => (
                <option key={time} value={time}>{time}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Shore Excursions</label>
            <textarea
              name="shore_excursions"
              value={formData.shore_excursions}
              onChange={handleInputChange}
              placeholder="Perfect Day at CocoCay, snorkeling, cultural tours..."
              className="form-control"
              rows="2"
            />
          </div>
          <div className="form-group">
            <label>Shore Excursions Price</label>
            <input
              type="number"
              name="shore_excursions_price"
              value={formData.shore_excursions_price}
              onChange={handleInputChange}
              placeholder="0.00"
              className="form-control"
              min="0"
              step="0.01"
            />
          </div>
        </div>

        <div className="form-group">
          <label>Onboard Activities</label>
          <textarea
            name="onboard_activities"
            value={formData.onboard_activities}
            onChange={handleInputChange}
            placeholder="FlowRider, rock climbing, zip line, pools, mini golf..."
            className="form-control"
            rows="2"
          />
        </div>

        <div className="form-group">
          <label>Entertainment</label>
          <textarea
            name="entertainment"
            value={formData.entertainment}
            onChange={handleInputChange}
            placeholder="Broadway-style shows, live music, comedy shows..."
            className="form-control"
            rows="2"
          />
        </div>
      </div>

      <div className="form-section">
        <h4>Specialty Dining & Services</h4>
        <div className="form-row">
          <div className="form-group">
            <label>Specialty Restaurants</label>
            <textarea
              name="specialty_restaurants"
              value={formData.specialty_restaurants}
              onChange={handleInputChange}
              placeholder="Chops Grille, Giovanni's Table, Izumi, Chef's Table..."
              className="form-control"
              rows="2"
            />
          </div>
          <div className="form-group">
            <label>Specialty Dining Price</label>
            <input
              type="number"
              name="specialty_dining_price"
              value={formData.specialty_dining_price}
              onChange={handleInputChange}
              placeholder="0.00"
              className="form-control"
              min="0"
              step="0.01"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Spa Services</label>
            <textarea
              name="spa_services"
              value={formData.spa_services}
              onChange={handleInputChange}
              placeholder="Vitality Spa treatments, salon services, thermal suite..."
              className="form-control"
              rows="2"
            />
          </div>
          <div className="form-group">
            <label>Spa Services Price</label>
            <input
              type="number"
              name="spa_services_price"
              value={formData.spa_services_price}
              onChange={handleInputChange}
              placeholder="0.00"
              className="form-control"
              min="0"
              step="0.01"
            />
          </div>
        </div>
      </div>

      <div className="form-section">
        <h4>Add-On Packages</h4>
        <div className="form-row">
          <div className="form-group">
            <label>Beverage Package</label>
            <select
              name="beverage_package"
              value={formData.beverage_package}
              onChange={handleInputChange}
              className="form-control"
            >
              {beveragePackageOptions.map(pkg => (
                <option key={pkg} value={pkg}>{pkg}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Beverage Package Price</label>
            <input
              type="number"
              name="beverage_package_price"
              value={formData.beverage_package_price}
              onChange={handleInputChange}
              placeholder="0.00"
              className="form-control"
              min="0"
              step="0.01"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Internet Package</label>
            <select
              name="internet_package"
              value={formData.internet_package}
              onChange={handleInputChange}
              className="form-control"
            >
              {internetPackageOptions.map(pkg => (
                <option key={pkg} value={pkg}>{pkg}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Internet Package Price</label>
            <input
              type="number"
              name="internet_package_price"
              value={formData.internet_package_price}
              onChange={handleInputChange}
              placeholder="0.00"
              className="form-control"
              min="0"
              step="0.01"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Photo Package</label>
            <select
              name="photo_package"
              value={formData.photo_package}
              onChange={handleInputChange}
              className="form-control"
            >
              {photoPackageOptions.map(pkg => (
                <option key={pkg} value={pkg}>{pkg}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Photo Package Price</label>
            <input
              type="number"
              name="photo_package_price"
              value={formData.photo_package_price}
              onChange={handleInputChange}
              placeholder="0.00"
              className="form-control"
              min="0"
              step="0.01"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Gratuities</label>
            <select
              name="gratuities"
              value={formData.gratuities}
              onChange={handleInputChange}
              className="form-control"
            >
              <option value="Included">Included</option>
              <option value="Not Included">Not Included</option>
              <option value="Prepaid">Prepaid</option>
            </select>
          </div>
          <div className="form-group">
            <label>Gratuities Price</label>
            <input
              type="number"
              name="gratuities_price"
              value={formData.gratuities_price}
              onChange={handleInputChange}
              placeholder="0.00"
              className="form-control"
              min="0"
              step="0.01"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Travel Protection</label>
            <select
              name="travel_protection"
              value={formData.travel_protection}
              onChange={handleInputChange}
              className="form-control"
            >
              <option value="Not Included">Not Included</option>
              <option value="Included">Included</option>
            </select>
          </div>
          {formData.travel_protection === 'Included' && (
            <div className="form-group">
              <label>Travel Protection Price</label>
              <input
                type="number"
                name="travel_protection_price"
                value={formData.travel_protection_price}
                onChange={handleInputChange}
                min="0"
                step="0.01"
                className="form-control"
              />
            </div>
          )}
        </div>
      </div>

      <div className="form-section">
        <h4>Pricing & Payment</h4>
        <div className="form-row">
          <div className="form-group">
            <label>Total Price *</label>
            <input
              type="number"
              name="total_price"
              value={formData.total_price}
              onChange={handleInputChange}
              min="0"
              step="0.01"
              className={`form-control ${errors.total_price ? 'error' : ''}`}
            />
            {errors.total_price && <span className="error-message">{errors.total_price}</span>}
          </div>
          <div className="form-group">
            <label>Total Due By</label>
            <input
              type="date"
              name="total_price_due_by"
              value={formData.total_price_due_by}
              onChange={handleInputChange}
              className="form-control"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Deposit Due</label>
            <input
              type="number"
              name="deposit_due"
              value={formData.deposit_due}
              onChange={handleInputChange}
              min="0"
              step="0.01"
              className="form-control"
            />
          </div>
          <div className="form-group">
            <label>Deposit Due By</label>
            <input
              type="date"
              name="deposit_due_by"
              value={formData.deposit_due_by}
              onChange={handleInputChange}
              className="form-control"
            />
          </div>
        </div>

        <div className="form-group">
          <label>Final Payment Due</label>
          <input
            type="date"
            name="final_payment_due"
            value={formData.final_payment_due}
            onChange={handleInputChange}
            className="form-control"
          />
        </div>
      </div>

      <div className="form-section">
        <h4>Special Requests & Celebrations</h4>
        <div className="form-group">
          <label>Special Requests</label>
          <textarea
            name="special_requests"
            value={formData.special_requests}
            onChange={handleInputChange}
            placeholder="Dietary restrictions, room requests, accessibility needs..."
            className="form-control"
            rows="3"
          />
        </div>

        <div className="form-group">
          <label>Celebration Details</label>
          <textarea
            name="celebration_details"
            value={formData.celebration_details}
            onChange={handleInputChange}
            placeholder="Birthday, anniversary, honeymoon, special occasions..."
            className="form-control"
            rows="2"
          />
        </div>

        <div className="form-group">
          <label>Accessibility Needs</label>
          <textarea
            name="accessibility_needs"
            value={formData.accessibility_needs}
            onChange={handleInputChange}
            placeholder="Wheelchair accessible stateroom, hearing assistance..."
            className="form-control"
            rows="2"
          />
        </div>
      </div>

      <div className="form-section">
        <h4>Children Information</h4>
        <div className="children-section">
          {formData.children.map((child, index) => (
            <div key={index} className="child-entry">
              <div className="form-row">
                <div className="form-group">
                  <label>Child {index + 1} Age</label>
                  <input
                    type="number"
                    value={child.age}
                    onChange={(e) => updateChild(index, 'age', e.target.value)}
                    min="0"
                    max="17"
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <button
                    type="button"
                    onClick={() => removeChild(index)}
                    className="btn btn-danger btn-sm"
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
          ))}
          <button
            type="button"
            onClick={addChild}
            className="btn btn-secondary btn-sm"
          >
            Add Child
          </button>
        </div>
      </div>

      <div className="form-section">
        <h4>Client Options</h4>
        
        <div className="form-row">
          <div className="form-group">
            <label>
              <input
                type="checkbox"
                checked={formData.isOption}
                onChange={(e) => setFormData({...formData, isOption: e.target.checked})}
              />
              Mark as Optional for Client
            </label>
            <small className="form-help">
              When checked, clients can choose whether to include this component in their booking
            </small>
          </div>
        </div>

        {formData.isOption && (
          <>
            <div className="form-group">
              <label>Option Description for Client</label>
              <textarea
                value={formData.optionDescription}
                onChange={(e) => setFormData({...formData, optionDescription: e.target.value})}
                placeholder="e.g., Optional Royal Caribbean cruise upgrade or cabin category"
                rows="2"
              />
              <small className="form-help">
                This description helps clients understand what this option includes
              </small>
            </div>

            <div className="form-group">
              <label>Payment Timing for Optional Component</label>
              <select
                value={formData.paymentTiming}
                onChange={(e) => setFormData({...formData, paymentTiming: e.target.value})}
                className="form-control"
              >
                <option value="immediate">Pay Full Price When Selected (e.g., cruise excursions)</option>
                <option value="with_deposit">Pay Deposit When Selected</option>
                <option value="with_final">Pay with Final Payment (nothing due initially)</option>
                <option value="bundled">Already Included in Package (no additional payment)</option>
              </select>
              <small className="form-help">
                Choose when payment is due if client selects this option
              </small>
            </div>

            {formData.paymentTiming === 'with_deposit' && (
              <div className="form-group">
                <label>Optional Component Deposit Amount ($)</label>
                <input
                  type="number"
                  value={formData.optionalDepositAmount}
                  onChange={(e) => setFormData({...formData, optionalDepositAmount: e.target.value})}
                  placeholder="0.00"
                  step="0.01"
                  min="0"
                  className="form-control"
                />
                <small className="form-help">
                  Amount due when client selects this option (leave blank for full price)
                </small>
              </div>
            )}
          </>
        )}
      </div>

      <AttachmentUpload
        photos={formData.photos}
        documents={formData.documents}
        onPhotosChange={(photos) => setFormData(prev => ({ ...prev, photos }))}
        onDocumentsChange={(documents) => setFormData(prev => ({ ...prev, documents }))}
      />

      <div className="form-actions">
        <button type="button" onClick={onCancel} className="btn btn-secondary">
          Cancel
        </button>
        <button type="submit" className="btn btn-primary">
          Save Royal Caribbean Cruise
        </button>
      </div>
    </form>
  );
};

export default RoyalCaribbeanCruiseForm;
